// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1ARlB","col":"styles_col__1rJmq"};